import { CurrentPaymentMethod } from './AccountTypes';
import { type SavedPaymentMethodFullResponse } from './FinancialAccount';
import { PaymentMethod } from './InboundPayments';

export interface FinancingDataStatementResponse {
  statementLink: string;
  date: string;
}

export interface FinancingDataPaymentResponse {
  amount: string;
  date: string;
  type: PAYMENT_TYPE;
  paymentMethod: PaymentMethod;
  reason?: string | null;
}

export enum PaymentTypeDescription {
  ONE_TIME_ACH = 'ONE TIME ACH',
  ONE_TIME_CC = 'ONE TIME CC',
}

export interface FinancingDataPendingPaymentResponse {
  paymentId: string;
  amount: number;
  paymentDate: string;
  entryDate: string;
  paymentTypeDescription: PaymentTypeDescription;
}

export interface FinancingDataResponse {
  firstPaymentDueDate: string | null;
  normalMonthlyBillingCharges: string;
  amountPastDue: string;
  totalDue: string;
  nextScheduledAutoPaymentDate: string;
  currentInvoiceLink: string | null;
  /** Full auto-pay payment method, same shape as GET /v2/accounts/:id/payment-methods. Null when none. */
  autoPayPaymentMethod: SavedPaymentMethodFullResponse | null;
  currentPaymentMethod: CurrentPaymentMethod | null;
  payments: FinancingDataPaymentResponse[];
  statements: FinancingDataStatementResponse[];
  lateChargeAmount: string;
  pendingPayments: FinancingDataPendingPaymentResponse[];
  hasScheduledOneTimePayment: boolean;
  concordDispositionCode: string;
  concordDispositionCodeDescription: string;
  isOneTimePaymentAllowed: boolean;
  daysDelinquent: number;
}

export enum PAYMENT_TYPE {
  PAYMENT = 'payment',
  ACH_PAYMENT_FAILURE = 'achPaymentFailure',
  CREDIT_CARD_PAYMENT_FAILURE = 'creditCardPaymentFailure',
}
